"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneFieldValueGetter = void 0;
const safe_field_value_1 = require("../../safe-field-value");
const custom_types_1 = require("../../type-checking/custom-types");
const typing_1 = require("../../type-checking/typing");
const primitives_1 = require("../../type-checking/primitives");
const arrays_1 = require("../../type-checking/arrays");
const phone_1 = require("../../type-checking/phone");
class PhoneFieldValueGetter extends safe_field_value_1.BaseFieldValueGetter {
    constructor() {
        super(...arguments);
        this.isValidFieldValue = (fieldValue) => {
            return (0, arrays_1.isArrayOfValidObjectsValue)(fieldValue, {
                id: (0, typing_1.Optional)(custom_types_1.isIDValue),
                phone_country: (0, typing_1.Optional)(phone_1.isCountryCodeValue),
                phone_number: (0, typing_1.Optional)(primitives_1.isStringValue),
                phone_extension: (0, typing_1.Optional)(primitives_1.isStringValue),
                phone_type: (0, typing_1.Optional)(phone_1.isPhoneTypesValue),
                sys_root: (0, typing_1.Optional)(primitives_1.isStringValue),
                sys_title: (0, typing_1.Optional)(primitives_1.isStringValue),
            });
        };
        this.getEmptyValue = () => [];
        this.isOptimizedFieldValue = (fieldValue) => {
            return (0, phone_1.isOptimizedPhoneValue)(fieldValue);
        };
        this.getValueFromOptimized = (fieldValue) => {
            return fieldValue.map((phone) => (0, phone_1.optimizedPhoneToPhone)(phone));
        };
    }
}
exports.PhoneFieldValueGetter = PhoneFieldValueGetter;
